// extracted by mini-css-extract-plugin
export default {"header":"DoXk","title":"_3ItD"};